import { createSlice } from "@reduxjs/toolkit";
import type CommandeArticleCartModel from "models/CommandeArticleCartModel";

interface CartParameters {
  payload: CommandeArticleCartModel;
  type: string;
}

const cartSlice = createSlice({
  name: "cart",
  initialState: [] as Array<CommandeArticleCartModel>,
  reducers: {
    /* eslint-disable no-param-reassign */
    addArticle: (state, { payload }: CartParameters) => {
      const foundArticle = state.find(
        (commandeArticleFormModel) =>
          commandeArticleFormModel.articleId === payload.articleId &&
          commandeArticleFormModel.taille === payload.taille
      );

      if (foundArticle == null) {
        state.push(payload);
      } else {
        const i = state.indexOf(foundArticle);
        state[i].quantite += payload.quantite;
        if (state[i].quantite > state[i].quantiteMax) {
          state[i].quantite = state[i].quantiteMax;
        }
      }
      return state;
    },
    deleteArticle: (state, { payload }: CartParameters) =>
      state.filter((p) => p.articleId !== payload.articleId || p.taille !== payload.taille),
    deleteArticles: (_state) => [],
    /* eslint-enable no-param-reassign */
  },
});

export const { addArticle, deleteArticle, deleteArticles } = cartSlice.actions;

export default cartSlice.reducer;
